// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Common = require("../utils/Common.res.js");
var MM_parser = require("../mm-utils/MM_parser.res.js");
var MM_wrk_client = require("./MM_wrk_client.res.js");
var Caml_js_exceptions = require("rescript/lib/js/caml_js_exceptions.js");

var procName = "MM_wrk_ParseMmFile";

function reqToStr(req) {
  return "ParseMmFile";
}

function respToStr(resp) {
  if (resp.TAG === "MmFileParseProgress") {
    return "MmFileParseProgress(pct=" + String(resp.pct) + ")";
  } else {
    return "MmFileParsed";
  }
}

function beginParsingMmFile(mmFileText, onProgress, onDone) {
  MM_wrk_client.beginWorkerInteraction(procName, {
        TAG: "ParseMmFile",
        mmFileText: mmFileText
      }, (function (resp, param, endWorkerInteraction) {
          if (resp.TAG === "MmFileParseProgress") {
            return onProgress(resp.pct);
          }
          endWorkerInteraction();
          onDone(resp.parseResult);
        }), undefined, undefined, undefined);
}

function processOnWorkerSide(req, sendToClient) {
  try {
    var parseResult = MM_parser.parseMmFile(req.mmFileText, undefined, undefined, (function (pct) {
            sendToClient({
                  TAG: "MmFileParseProgress",
                  pct: pct
                });
          }));
    sendToClient({
          TAG: "MmFileParseProgress",
          pct: 1
        });
    return sendToClient({
                TAG: "MmFileParsed",
                parseResult: {
                  TAG: "Ok",
                  _0: parseResult
                }
              });
  }
  catch (raw_exn){
    var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
    if (exn.RE_EXN_ID === Common.MmException) {
      return sendToClient({
                  TAG: "MmFileParsed",
                  parseResult: {
                    TAG: "Error",
                    _0: exn._1.msg
                  }
                });
    }
    throw exn;
  }
}

exports.procName = procName;
exports.beginParsingMmFile = beginParsingMmFile;
exports.processOnWorkerSide = processOnWorkerSide;
exports.reqToStr = reqToStr;
exports.respToStr = respToStr;
/* Common Not a pure module */
